export enum ContentType {
  EMPTY = 'Empty',
  DEFAULT_BRANCH = 'Default Branch',
  FROM_TEMPLATE = 'From Template',
}
